import React from 'react';
import { BodySmall, BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import Icon, { IconTypes } from '@shared/ui/atoms/icon/Icon';
import styled from "styled-components";
import { BORDER_SOLID, MEETING_ROOM_HEADER_HEIGHT, MEETING_ROOM_SWIMLANE_WIDTH } from "./StructuralComponents";

export function MeetingRoomTitle(props: Props) {
  return (
    <Header>
      <BodySmall className={'meetingRoom__label'} style={{marginBottom: -2}} colour={Colours.veryDarkBlue} weight={600}>{props.name}</BodySmall>
      {props.subTitle && <BodyVerySmall style={{marginBottom: 2}} className={'meetingRoom__label'} colour={Colours.veryDarkBlue} weight={400}>{props.subTitle}</BodyVerySmall>}
      <Row>
        {props.isOutlook ? <IconImage src={"/assets/icons/Outlook.svg"}
                                      title={'Managed via Outlook'}
                                      alt={"Outlook"} /> : <IconImage src={"/assets/icons/shape.svg"}
                                                                      title={'Managed via Team Today'}
                                                                      alt={"TeamToday"} />}
        <Icon style={{marginRight: 8}} icon={IconTypes.Profile} />
        <BodyVerySmall weight={400} colour={Colours.veryDarkBlue}>{props.capacity}</BodyVerySmall>
      </Row>
    </Header>
  )
}

interface Props {
  name: string;
  capacity: number;
  isOutlook: boolean;
  subTitle?: string;
}

const Row = styled.div`
  display: flex;
  align-items: center;
`

const Header = styled.div`
  box-shadow: 0 4px 2px -2px rgba(46, 74, 148, 0.08);
  padding: 12px 16px;
  width: ${MEETING_ROOM_SWIMLANE_WIDTH}px;
  min-width: ${MEETING_ROOM_SWIMLANE_WIDTH}px;
  max-width: ${MEETING_ROOM_SWIMLANE_WIDTH}px;
  height: ${MEETING_ROOM_HEADER_HEIGHT}px;
  overflow: hidden;
  background-color: white;
  border-right: ${BORDER_SOLID};
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 9;
  .icon {
    color: ${Colours.veryDarkBlue} !important;
  }
  .meetingRoom__label {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`

const IconImage = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 6px;
`
